import { memo } from 'react';
import { TextStyle } from 'react-native';
import { COIN_SIZE } from '../AnimatedCoin/AnimatedCoin.content';
import { SHADOW_COLORS } from './AnimatedBurst.content';
import { AnimatedBurstProps } from './AnimatedBurst.types';
import useStyle from '../../../hooks/useStyle';
import Box from '../../Box/Box';

function AnimatedBurst({ index, ...rest }: AnimatedBurstProps) {
  const { color: shadowColor } = useStyle<TextStyle>({
    color: SHADOW_COLORS[index % 3],
  });

  return (
    <Box
      {...rest}
      position="absolute"
      width={COIN_SIZE * 2}
      height={COIN_SIZE * 2}
      borderRadius="radius-full"
      borderColor={index % 2 === 0 ? 'borderGoldSolid' : 'borderActive'}
      borderWidth="border-width-050"
    >
      <Box
        absoluteFill
        borderRadius="radius-full"
        boxShadow={`0 0 40px 0 ${shadowColor?.toString()}, inset 0 0 24px 0 ${shadowColor?.toString()}`}
      />
    </Box>
  );
}

export default memo(AnimatedBurst);
